module.exports = __webpack_public_path__ + "img/T4-C-xh_19.bbe59548.png";